var tablet_break = 900;
var max_wrap = 1400;
var bank_name = "Greenfield Cooperative Bank";

// Since these sections are all universal, make them constants for the rest of the code
const MOBILEMENU = document.getElementById("nav-menu-mobile");
const SEARCHMENU = document.getElementById("nav-menu-search");
const DESKTOPNAV = document.getElementById("header-desktop");
const MOBILENAV = document.getElementById("header-mobile");
const HEADERS = document.getElementById("header-container");
const URLHASH = window.location.hash;